export function initDoctorsList() {
    const doctorsContainer = document.querySelector<HTMLElement>('.doctors');
    const doctors = doctorsContainer?.querySelectorAll<HTMLElement>('.doctor-item');
    const showMoreBtn = document.querySelector<HTMLButtonElement>(
        '.button.button-border-b'
    );
    const searchInput = document.querySelector<HTMLInputElement>('.input-search_doctors');
    const header = document.querySelector<HTMLElement>('.header');

    if (!doctorsContainer || !doctors || !showMoreBtn || !searchInput) return;

    const MAX_VISIBLE = 6;

    // Скрытие/показ карточек через класс, а не inline-style
    function hideDoctor(doctor: HTMLElement) {
        doctor.classList.add('is-hidden');
    }
    function showDoctor(doctor: HTMLElement) {
        doctor.classList.remove('is-hidden');
    }

    function updateInitialState() {
        doctors.forEach((doctor, index) => {
            if (index < MAX_VISIBLE) {
                showDoctor(doctor);
            } else {
                hideDoctor(doctor);
            }
        });

        showMoreBtn.style.display = doctors.length > MAX_VISIBLE ? '' : 'none';
    }

    function showAllDoctors() {
        doctors.forEach(showDoctor);
        showMoreBtn.style.display = 'none';
    }

    function filterDoctors(query: string) {
        const normalized = query.trim().toLowerCase();
        let matches = 0;

        doctors.forEach((doctor) => {
            const nameEl = doctor.querySelector<HTMLElement>('.doctor-item__name');
            const text = nameEl?.textContent?.toLowerCase() ?? '';

            const match = text.includes(normalized);
            if (match) {
                showDoctor(doctor);
                matches++;
            } else {
                hideDoctor(doctor);
            }
        });

        // Кнопка скрыта, если идёт поиск
        showMoreBtn.style.display = normalized ? 'none' : doctors.length > MAX_VISIBLE ? '' : 'none';

        if (!normalized) {
            updateInitialState();
        }
    }

    // Плавный скролл при фокусе
    function scrollToInput() {
        const headerHeight = header?.offsetHeight ?? 0;
        const rect = searchInput.getBoundingClientRect();
        const scrollTop = window.pageYOffset + rect.top - headerHeight - 20;

        window.scrollTo({
            top: scrollTop,
            behavior: 'smooth',
        });
    }

    // Инициализация
    updateInitialState();

    // Слушатели
    showMoreBtn.addEventListener('click', showAllDoctors);
    searchInput.addEventListener('input', () => filterDoctors(searchInput.value));
    searchInput.addEventListener('focus', scrollToInput);
}
